"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomTickWrapper = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var O = __importStar(require("fp-ts/Option"));
var function_1 = require("fp-ts/function");
var React = __importStar(require("react"));
var BarChart_1 = require("./BarChart");
exports.CustomTickWrapper = React.memo(function (p) { return ((0, jsx_runtime_1.jsx)(CustomTick, { data: p.data, height: p.height, width: p.width, y: p.y, payload: p.payload })); });
var renderTick = function (p, tick, anchor) { return ((0, jsx_runtime_1.jsx)("text", __assign({ textAnchor: anchor, height: p.height, stroke: "none", width: p.width, x: p.payload.coordinate, y: p.y, fill: BarChart_1.BarChartShark.COLOR_VERY_DARK_GREY }, { children: (0, jsx_runtime_1.jsx)("tspan", __assign({ x: p.payload.coordinate, dy: "0.9em" }, { children: tick })) }))); };
var CustomTick = React.memo(function (p) {
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, function_1.pipe)(O.fromNullable(p.data), O.match(function () { return renderTick(p, "".concat(p.payload.value), 'middle'); }, function (d) { return (p.payload.value === 0 ? null : renderTick(p, d[p.payload.value - 1], 'end')); })) }));
});
//# sourceMappingURL=CustomTick.js.map